module.exports = __webpack_public_path__ + "img/24sata.66d6cb64.svg";